"use client";

import Image from "next/image";

export default function Background_Primary({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative w-full min-h-screen bg-surface overflow-hidden">
      {/* Decorative Images */}
      <Image
        src="/ellipse.png"
        alt="Ellipse"
        width={200}
        height={200}
        className="surface-decoration absolute -top-16 -right-16"
      />

      <Image
        src="/vector.png"
        alt="Vector"
        width={150}
        height={150}
        className="surface-decoration absolute -top-1 -right-1"
      />

      {/* Page Content */}
      <div className="relative z-10 w-full h-full">{children}</div>
    </div>
  );
}
